import { IdNameApiModel } from '@app/api/api-models/IdNameApiModel';
import { IdName } from '@app/shared/models';
import { FormMinimalApiModel } from '../forms';

export class AlertsSelectorsApiModel {
  public Groups: IdNameApiModel[];
  public Phases: IdNameApiModel[];
  public Forms: FormMinimalApiModel[];
  public Ratings: IdNameApiModel[];
  public Quizzes: IdNameApiModel[];
  public IncidentTypes: IdNameApiModel<string>[];
  public CorrectiveActions: IdNameApiModel<string>[];
  public EvaluationPeriods: IdNameApiModel<string>[];

  public scores?: IdName[];

  public deserialize(data: Object): AlertsSelectorsApiModel {
    Object.assign(this, data);

    this.scores = this.Ratings.map((_x, i) => new IdName(i + 1, (i + 1).toString()));

    return this;
  }
}
